import React, { useState } from "react";
import Joi from "joi-browser";
import { useDispatch } from "react-redux";
import SecurityQuestion from "./SecurityQuestion";
import ThankYou from "./ThankYou";
import useForm from "../../hooks/useForm";
import {
  verifyUserByUserName,
  sendSecurityCodeToEmail,
  sendSecurityCodeToPhone,
  verifySecurityCode,
} from "../../app/store/auth";

const schema = {
  // username: Joi.string().required().label("User Name"),
  // userType: Joi.string().required().label("User Type"),
  email: Joi.string().email().required().label("Email"),
};

const ForgotPwd = ({ handlePwdBack, urlData, forgotType }) => {
  const { data, setData, errors, setErrors, renderInput, validate, handleSubmit } =
    useForm(schema, {});

  const dispatch = useDispatch();

  const [securityQuestion, setSecurityQuestion] = useState(false);
  const [pwdBlock, setPwdBlock] = useState(true);
  const [userTypes] = useState([]);
  const [secQuestion, setSecQuestion] = useState("");
  const [emailAuth, setEmailAuth] = useState(false);
  const [phoneAuth, setPhoneAuth] = useState(false);
  const [securityAuth, setSecurityAuth] = useState(false);
  const [thankYou, setThankYou] = useState(false);
  const [questionAuth, setQuestionAuth] = useState(false);
  const [sendCodeBtnLoding, setSendCodeBtnLoding] = useState(false);
  const [verifyBtnLoding, setVerifyBtnLoding] = useState(false);
  const [reSendCodeBtnLoding, setReSendCodeBtnLoding] = useState(false);
  const [reSendCodeMsg, setReSendCodeMsg] = useState(false);

  const handleSecurityQuestion = (question) => {
    setSecurityQuestion(true);
    setPwdBlock(false);
    setSecQuestion(question);
  };

  const handleQuestionBack = () => {
    setSecurityQuestion(false);
    setQuestionAuth(true);
    setPwdBlock(true);
  };

  const doSubmit = async () => {
    const result = await dispatch(verifyUserByUserName(data));
    if (result !== null && result !== "") {
      handleSecurityQuestion(result);
    } else {
      setErrors({ ...errors, username: "Invalid Details" });
    }
  };

  const handleEmailAuth = () => {
    setEmailAuth(true);
    setPhoneAuth(false);
    setData({});
    setErrors({});
  };

  const handlePhoneAuth = () => {
    setPhoneAuth(true);
    setEmailAuth(false);
    setData({});
    setErrors({});
  };

  const handleSecurityCode = async () => {
    if (data["userName"] === "" || data["userName"] === undefined) {
      setErrors({ ...errors, userName: "Please enter username" });
    } else if (
      data["email"] === "" ||
      (data["email"] === undefined && emailAuth)
    ) {
      setErrors({ ...errors, email: "Please enter email" });
    } else if (
      data["phone"] === "" ||
      (data["phone"] === undefined && phoneAuth)
    ) {
      // no-op, preserved from original
    } else {
      setSendCodeBtnLoding(true);
      if (emailAuth && !phoneAuth) {
        const result = await dispatch(
          sendSecurityCodeToEmail(data["userName"], data["email"], forgotType)
        );

        if (result === "fail") {
          setErrors({ ...errors, email: "Invalid Details" });
          setSendCodeBtnLoding(false);
        } else {
          setSecurityAuth(true);
          setSendCodeBtnLoding(false);
        }
      }

      if (phoneAuth && !emailAuth) {
        const result = await dispatch(
          sendSecurityCodeToPhone(data["userName"], data["phone"], forgotType)
        );

        if (result === "fail") {
          setErrors({ ...errors, phone: "Invalid Details" });
        } else {
          setSecurityAuth(true);
          setSendCodeBtnLoding(false);
        }
      }
    }
  };

  const handleVerifyCode = async () => {
    if (data["securityCode"] === "" || data["securityCode"] === undefined) {
      setErrors({ ...errors, securityCode: "Please enter security code" });
    } else {
      setVerifyBtnLoding(true);
      let email = data["email"];
      if (phoneAuth) email = data["phone"];
      const result = await dispatch(
        verifySecurityCode(email, data["securityCode"], "pwd")
      );
      if (result === "success") {
        setThankYou(true);
        setPwdBlock(false);
        setVerifyBtnLoding(true);
        setErrors({});
      } else {
        setErrors({ ...errors, securityCode: "Invalid Code" });
        setVerifyBtnLoding(false);
      }
    }
  };

  const handleQuestionAuth = () => {
    setQuestionAuth(true);
    setEmailAuth(false);
    setPhoneAuth(false);
    setData({});
    setErrors({});
  };

  const handleBack = () => {
    if (!securityAuth && emailAuth) {
      setEmailAuth(!emailAuth);
    }
    if (!securityAuth && phoneAuth) {
      setPhoneAuth(!phoneAuth);
    }
    if (!securityAuth && questionAuth) {
      setQuestionAuth(!questionAuth);
    }

    if (emailAuth || phoneAuth || questionAuth) {
      setSecurityAuth(false);
    } else {
      handlePwdBack();
    }
  };

  const handleResendCode = async () => {
    setReSendCodeBtnLoding(true);
    if (emailAuth && !phoneAuth) {
      const result = await dispatch(
        sendSecurityCodeToEmail(data["userName"], data["email"], forgotType)
      );
      if (result === "fail") {
        setErrors({ ...errors, email: "Invalid Details" });
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(false);
      } else {
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(true);
      }
    }

    if (phoneAuth && !emailAuth) {
      const result = await dispatch(
        sendSecurityCodeToPhone(data["userName"], data["phone"], forgotType)
      );
      if (result === "fail") {
        setErrors({ ...errors, phone: "Invalid Details" });
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(false);
      } else {
        setReSendCodeBtnLoding(false);
        setReSendCodeMsg(true);
      }
    }
  };

  return (
    <React.Fragment>
      {pwdBlock && (
        <div className="row">
          <div className="form-group col-md-12">
            <button className="btn btn-link pl-0" onClick={handleBack}>
              <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
              Back
            </button>
          </div>
          {/* <div className="col-md-12">
            {renderSelect(
              "userType",
              "Identify Yourself",
              userTypes,
              "name",
              "name"
            )}
          </div> */}
          {questionAuth && (
            <React.Fragment>
              <div className="col-md-12">
                {renderInput("username", "Enter Your Username")}
              </div>
              <div className="col-md-12">
                {renderInput("email", "Enter Your Registered Email")}
              </div>
              <div className="col-md-12">
                <button
                  className="btn btn-outline-default w-100"
                  disabled={Boolean(validate())}
                  onClick={(e) => handleSubmit(e, doSubmit)}
                >
                  Next
                </button>
              </div>
            </React.Fragment>
          )}

          {!emailAuth && !phoneAuth && !questionAuth && (
            <div className="col-md-12 text-center">
              <h2 className="mb-3">Verify Your Identity</h2>
              <p>
                You will now be required to enter One-Time Security Code to
                verify your identity.
              </p>
              <br />
              <h5>How would you like to receive the code?</h5>
              <br />
              <button
                className="btn btn-outline-default"
                onClick={handleEmailAuth}
              >
                Send To My Email
              </button>
              {/* <button
                className="btn btn-outline-default"
                onClick={handlePhoneAuth}
              >
                Text To My Mobile
              </button> */}
              <button
                className="btn btn-outline-default"
                onClick={handleQuestionAuth}
              >
                Security Question
              </button>
            </div>
          )}
          {(emailAuth || phoneAuth) && (
            <div className="col-md-12">
              {renderInput("userName", "Enter Your Username")}
            </div>
          )}
          {emailAuth && (
            <div className="col-md-12">
              {renderInput("email", "Enter Your Registered Email")}
            </div>
          )}
          {/* {phoneAuth && (
            <div className="col-md-12">
              {renderInput(
                "phone",
                "Enter Your Registered Mobile Number"
              )}
            </div>
          )} */}
          {securityAuth && (
            <div className="col-md-12">
              {renderInput(
                "securityCode",
                "Enter Your Code Below To Continue"
              )}
            </div>
          )}
          {(emailAuth || phoneAuth) && !securityAuth && (
            <div className="col-md-12 text-center">
              <button
                className="btn btn-outline-default"
                disabled={sendCodeBtnLoding}
                onClick={handleSecurityCode}
              >
                {sendCodeBtnLoding && (
                  <i className="fa fa-refresh fa-spin mr-2"></i>
                )}
                Send Security Code To My {emailAuth && " email"}
                {phoneAuth && " mobile"}
              </button>
            </div>
          )}
          {securityAuth && (
            <div className="col-md-12 text-center">
              <button
                className="btn btn-outline-default"
                disabled={verifyBtnLoding}
                onClick={handleVerifyCode}
              >
                {verifyBtnLoding && (
                  <i className="fa fa-refresh fa-spin mr-2"></i>
                )}
                Verify
              </button>
              <br />
              <br />
              <p>Didn't receive the code?</p>
              <button
                className="btn btn-sm btn-link pl-0"
                disabled={reSendCodeBtnLoding}
                onClick={handleResendCode}
              >
                {reSendCodeBtnLoding && (
                  <i className="fa fa-refresh fa-spin mr-2"></i>
                )}
                Resend Code
              </button>
              {reSendCodeMsg && (
                <span className="text-red">
                  Security Code Sent Successfully
                </span>
              )}
            </div>
          )}
        </div>
      )}
      {thankYou && <ThankYou forgotType="pwd" urlData={urlData}></ThankYou>}
      {securityQuestion && (
        <SecurityQuestion
          handleQuestionBack={handleQuestionBack}
          secQuestion={secQuestion}
          userType={data["userType"]}
          forgotType="pwd"
          urlData={urlData}
        ></SecurityQuestion>
      )}
    </React.Fragment>
  );
};

export default ForgotPwd;
